import {Component, inject} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {brand} from '../../../../../../src/app/settings';

@Component({
    selector: 'app-demo-choice',
    imports: [
        TranslateModule,
        MatIconModule
    ],
    templateUrl: './demo-choice.component.html'
})

export class DemoChoiceComponent {
    private router = inject(Router);

    public brand = brand;

    playJunior(): void {
        this.router.navigate(['demo', 'junior'], {queryParamsHandling: 'preserve'});
    }

    playCollege(): void {
        this.router.navigate(['demo', 'explorer'], {queryParamsHandling: 'preserve'});
    }

    playPython(): void {
        this.router.navigate(['demo', 'backend-driven'], {queryParamsHandling: 'preserve'});
    }
}
